import { useAppSelector } from "hooks";
// material-ui
import {Typography} from '@mui/material';

// project imports
import NavGroup from './NavGroup';
import menuItem from 'menu-items';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    const user = useAppSelector((state) => state.user);

    const roles = user.info?.roles || [];

    const navItems = menuItem.items
        .filter((item) => {
            if (item.authority) return roles.includes(item.authority);

            // No group-level authority: show if any child is accessible
            if (item.children) {
                return item.children.some((child) => !child.authority || roles.includes(child.authority));
            }
            return true;
        })
        .map((item) => {
            switch (item.type) {
                case 'group':
                    return <NavGroup key={item.id} item={item}/>;
                default:
                    return (
                        <Typography key={item.id} variant="h6" color="error" align="center">
                            Menu Items Error
                        </Typography>
                    );
            }
        });

    return <>{navItems}</>;
};

export default MenuList;
